import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'auth/context/AuthContext';
import { AUTH_SIGN_UP_PROVIDER } from 'utilities/routes';
import { ProviderPendingApproval } from 'app/my-account/pages/provider-pending-approval/ProviderPendingApproval';
import StartTrial from 'app/my-account/pages/provider-pending-approval/StartTrial';

export const ProviderStatusGuard: React.FC = () => {
  const { user, loadingUserFullInfo, stripeSubscription } = useAuth();

  if (!user?.displayName && !loadingUserFullInfo) {
    return <Navigate to={AUTH_SIGN_UP_PROVIDER} replace />;
  }

  const isApproved = Boolean(user?.providerEnabled);
  const hasActiveSubscription = Boolean(stripeSubscription?.length);

  if (!isApproved) {
    return <ProviderPendingApproval />;
  }

  if (!hasActiveSubscription) {
    return <StartTrial />;
  }

  return <Outlet />;
};
